export default __webpack_public_path__ + "static/media/appRightImgTree.52ec39fa.png";